import { isNullOrUndefined } from "utils";

export const toleranceToFormula = (formula, tolerance) => {
  const updatedFormula = formula?.split(" ")?.map((i) => {
    const match = tolerance.values.find((v) => i.includes(v.key));
    if (isNullOrUndefined(match)) return i;
    return match.value;
  });

  return updatedFormula?.join(" ");
};

export const splitByChars = (str) => {
  const chunkSize = 145;
  const chunks: string[] = [];

  for (let i = 0; i < str?.length; i += chunkSize) {
    chunks.push(str.slice(i, i + chunkSize));
  }

  return chunks;
};
